import { createContext, useContext } from 'react';

// Which navigation shell wraps the page. GeneralLayout provides it; pages
// outside GeneralLayout get the sidebar default. Controls that duplicate the
// top bar, such as the Home button the logo replaces, read it to step aside.
export type NavigationShell = 'sidebar' | 'topbar';

export const NavigationShellContext = createContext<NavigationShell>('sidebar');

export function useNavigationShell(): NavigationShell {
  return useContext(NavigationShellContext);
}
